import React from 'react'
import { iconsCreator } from 'utils/iconsCreator'
import { useStyles } from './errorValidationIcon.css'

const ErrorValidationIcon = (props) => {
  const classes = useStyles()
  if (props.isValid === true) { return null }
  return <span className={`${classes.icon} ${classes.red}`} title={props.title} style={{ backgroundColor: props.backgroundColor }}>{iconsCreator('ErrorOutlineIcon', props.iconProps)}</span>
}

export {
  ErrorValidationIcon
}